import { Checkbox, FormControl, InputLabel, ListItemText, MenuItem, OutlinedInput, Select, ThemeProvider } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import Chart from 'react-apexcharts';
import { useTranslation } from 'react-i18next';

import { SelectComponent } from '../../../Components/shared/ReusableSmallComponents';
import SelectPeriod from '../../../Components/shared/SelectPeriod';
import { PeriodeDashboard } from '../../../data/Interfaces';
import useWindowSize from '../../../hooks/useWindowSize';
import { FieldComponentFont } from '../../../Styles/componentStyles';
import { filtreListPeriode } from '../DashbordBackOffice';
import { getInfosGraphAosCount, listStautAO } from './InterfacesDashboards';

function TotalAo({dataAllAos,filtreClient,selectedClient,clientName,width,height}){

    TotalAo.propTypes = {
        dataAllAos: PropTypes.any,
        filtreClient: PropTypes.any,
        selectedClient: PropTypes.any,
        clientName: PropTypes.any,
        width:PropTypes.any,
        height:PropTypes.any,
    };

    const { inputSize } = useWindowSize();
    const { i18n } = useTranslation();
    const [selectedClientCheckBox, setSelectedClientCheckBox] = useState(['all']);
    const [selectedPeriodAos, setSelectedPeriodAos] = useState('thisMonth');
    const [customDateRangeAos, setCustomDateRangeAos] = useState({});
    const [filtreAOStatuts, setFiltreAOStatuts] = useState(['open']);
    const [chartDataAos, setChartDataAos] = useState({
        options: {
            chart: {
                type: 'bar',
                //height: 350,
                toolbar: {
                    show: true
                },
                zoom: {
                    enabled: true
                }
            },
            plotOptions: {
                bar: {
                    horizontal: false,
                    columnWidth: '15%',
                    endingShape: 'rounded',
                },
            },
            dataLabels: {
                enabled: false,
            },
            stroke: {
                show: true,
                width: 2,
                colors: ['transparent'],
            },
            fill: {
                opacity: 1,
            },
            yaxis: {
                type: 'numeric', // Specify the type as 'numeric'
                labels: {
                    formatter: function (val) {
                        // Use a formatter function to format the labels as integers
                        return Math.round(val);
                    },
                },
            },
        },
        series: [], // Initialize an empty array for the series
    });

    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: 250,
            },
        },
    };

    useEffect(() => {
        var filteredData;
        if(dataAllAos && Array.isArray(dataAllAos) && dataAllAos.length > 0){
            filteredData = dataAllAos.filter((item) => item.type=='ao');
            if(filtreClient){
                if (!selectedClientCheckBox.includes('all')) {
                    filteredData = dataAllAos.filter(
                        (item) => selectedClientCheckBox.includes(item.companyDataId)
                    );
                }
            }
            filteredData=filtreListPeriode(filteredData,selectedPeriodAos,customDateRangeAos);

            if(filtreAOStatuts!='all')
                filteredData = filteredData.filter(
                    (item) => filtreAOStatuts==item.status
                );

            const { dates,data} = getInfosGraphAosCount(filteredData,filtreClient,selectedClient,clientName);

            setChartDataAos(() => {
                return {
                    ...chartDataAos,
                    options:{
                        ...chartDataAos.options,
                        xaxis: {
                            categories: dates,
                            //type: 'datetime', // Set x-axis type to 'datetime'
                            //tickAmount: 'dataPoints',
                        },

                    },
                    series: data

                };
            });
        }
    },[selectedPeriodAos,filtreAOStatuts,selectedClient,customDateRangeAos,selectedClientCheckBox,dataAllAos]);

    return (
        <>
            <div
                className='graph1'
                style={{width:width,height:height}}
            >
                <h1 className='dashFrame5'>{i18n.t('Total AO')}</h1>
                <div className='filtre1'>
                    {filtreClient &&
                        <div style={{width:'35%'}}>
                            <ThemeProvider theme={FieldComponentFont}>
                                <FormControl style={{width:'100%'}}>
                                    <InputLabel
                                        shrink={true}
                                    >{i18n.t('Clients')} </InputLabel>
                                    <Select
                                        labelId="Clients"
                                        id="Clients"
                                        label='Clients'
                                        multiple
                                        value={selectedClientCheckBox}
                                        onChange={(event)=>{
                                            const {
                                                target: { value },
                                            } = event;
                                            setSelectedClientCheckBox(
                                            // On autofill we get a stringified value.
                                                typeof value === 'string' ? value.split(',') : value,
                                            );
                                            if(value.length>0){
                                                if (value[value.length - 1] == 'all') {
                                                    setSelectedClientCheckBox(['all']);
                                                } else {
                                                    // If 'all' was selected before, remove it from selectedClientCheckBox
                                                    const updatedSelected = value.includes('all')
                                                        ? value.filter((item) => item !== 'all')
                                                        : value;
                                                    console.log('updatedSelected',updatedSelected);

                                                    setSelectedClientCheckBox(updatedSelected);
                                                }
                                            }
                                        }}
                                        size={inputSize}
                                        sx={{
                                            '& > :not(style)': {borderRadius: '8px' },
                                        }}
                                        style={{ width: '100%', background: 'white' }}
                                        input={<OutlinedInput label="Clients" />}
                                        renderValue={(selected) => {
                                            return selected
                                                .map((id) => {
                                                    const selectedOption = selectedClient.find(
                                                        (element) => element._id === id
                                                    );
                                                    return i18n.t(selectedOption?.label);
                                                })
                                                .join(', ');
                                        }}
                                        MenuProps={MenuProps}
                                    >
                                        {Array.isArray(selectedClient) && selectedClient?.map((element) => (
                                            <MenuItem
                                                key={element._id}
                                                value={element._id}
                                            >
                                                <Checkbox checked={selectedClientCheckBox.includes(element._id)} />
                                                <ListItemText primary={i18n.t(element.label)} />
                                            </MenuItem>
                                        ))}

                                    </Select>
                                </FormControl>
                            </ThemeProvider>
                        </div>
                    }
                    <div style={{width:'35%'}}>
                        <SelectPeriod
                            selectedPeriod={selectedPeriodAos}
                            setSelectedPeriod={setSelectedPeriodAos}
                            setCustomDateRange={setCustomDateRangeAos}
                            listeVal={PeriodeDashboard}

                        />
                    </div>
                    <div style={{width:'35%'}}>
                        <SelectComponent
                            label={i18n.t('Statut besoin')}
                            val={filtreAOStatuts}
                            name='StatutAO'
                            setVal={(e) => {
                                setFiltreAOStatuts(e.target.value);
                            }}
                            listVal={listStautAO}
                        />
                    </div>

                </div>
                <div style={{height:'400px'}}>
                    <Chart
                        options={chartDataAos.options}
                        series={chartDataAos.series}
                        type="bar"
                        height={'85%'}
                        width={'100%'}
                    />
                </div>

            </div>
        </>
    );
}
export default TotalAo;